import NetxQueryClient, {
	type SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {getResponseResults} from '@netx/core-next/utils/api';
import {type IAttributeVocabulary} from '../schema';

/**
 * `setAttributeVocabulary` request params
 * (what is used to send to server)
 */

export type SetAttributeVocabularyRequestOptions = {
	id: number;
	name: string;
};

/**
 * `setAttributeVocabulary` request
 * (what sets sent to the server)
 */
export type SetAttributeVocabularyRequest = [
	SetAttributeVocabularyRequestOptions['id'],
	SetAttributeVocabularyRequestOptions['name'],
];

/**
 * `setAttributeVocabulary` response
 * (what comes back from the server)
 */
export type SetAttributeVocabularyResponse =
	SuccessResponse<SetAttributeVocabularyResult>;

/**
 * `setAttributeVocabulary` result
 * (what is utilized from the server response)
 */
export type SetAttributeVocabularyResult = IAttributeVocabulary;

export const setAttributeVocabularyEndpoint = 'setAttributeVocabulary';

/**
 * Set attribute vocabularies list
 * @param fetchParams Fetch params

 */
export const setAttributeVocabulary = async ({
	id,
	name,
}: SetAttributeVocabularyRequestOptions): Promise<SetAttributeVocabularyResult> => {
	const client = NetxQueryClient();

	const requestParams: SetAttributeVocabularyRequest = [id, name];

	return client
		.post<SetAttributeVocabularyResponse>(
			setAttributeVocabularyEndpoint,
			requestParams,
			{},
		)
		.then(getResponseResults);
};

export default setAttributeVocabulary;
